module.exports = __webpack_public_path__ + "static/media/bar-horiz-100-icon.8f3a8817.svg";